import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-marker-icon-city",
  "use": "spr-marker-icon-city-usage",
  "viewBox": "0 0 24 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 28\" id=\"spr-marker-icon-city\"><path fill-rule=\"evenodd\" fill=\"#FFF\" d=\"M23 28H1a.999.999 0 1 1 0-1.995v-13.97a1 1 0 0 1 1-.998h3V4.052a.996.996 0 0 1 1.124-.99c.985.123 4.575.659 6.876 2.085V1.058A.999.999 0 1 1 14.6.26l4 2.994c.252.188.4.484.4.798v5.489l1.6 1.197c.252.188.4.484.4.798v5.488l1.6 1.198c.252.188.4.484.4.798v6.985A.998.998 0 1 1 23 28zM3 13.033v12.972h2V13.033H3zm10 .997V8.043c0-1.208-3.198-2.322-6-2.828v20.79h6V14.03zm4-9.479l-2-1.497v3.493l2 1.497V4.551zm2 7.484l-4-2.994v3.493l4 2.994v-3.493zm2 7.484l-6-4.491v10.977h6v-6.486z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/marker-icon-city.svg
// module id = 264
// module chunks = 0